import { styles } from './ContentBlock.styles';

export interface ContentBlockProps {
  title?: string;
  text: string;
  isShortValue?: boolean;
}

/**
 * Компонент для отображения блока контента с заголовком и текстом
 */
export function ContentBlock({ title, text, isShortValue }: ContentBlockProps) {
  const slots = styles();

  return (
    <div>
      {title && <h4 className={slots.title()}>{title}</h4>}
      <p className={`${slots.text()} ${!isShortValue ? slots.fullText() : ''}`}>
        {text}
      </p>
    </div>
  );
}
